import { CheckCircle2 } from 'lucide-react';

interface AuthLayoutProps {
  children: React.ReactNode;
}

const features = [
  'One script tag — zero backend setup',
  'Real subscribers, not vanity metrics',
  'Live analytics from day one',
  'Bot-protected, clean data',
  'Built for solo founders, not enterprise teams',
];

export default function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="min-h-screen flex">
      {/* Left panel — form */}
      <div className="flex flex-col justify-center w-full lg:w-1/2 px-6 py-12 sm:px-12 xl:px-20 bg-white">
        {children}
      </div>

      {/* Right panel — brand */}
      <div className="hidden lg:flex flex-col justify-center w-1/2 px-14 xl:px-20 bg-gradient-to-br from-brand-500 via-brand-600 to-brand-800 text-white relative overflow-hidden">
        {/* Decorative circles */}
        <div className="absolute -top-24 -right-24 w-72 h-72 rounded-full bg-white/5" />
        <div className="absolute -bottom-20 -left-20 w-64 h-64 rounded-full bg-white/5" />
        <div className="absolute top-1/3 right-8 w-40 h-40 rounded-full border border-mint/20" />

        <div className="relative z-10 max-w-md">
          <p className="text-white/60 text-sm font-semibold tracking-widest uppercase mb-4">
            PreLaunch Waitlist
          </p>
          <h2 className="text-3xl xl:text-4xl font-bold leading-tight mb-4">
            Know if your idea has legs — <span className="italic">before you build a thing.</span>
          </h2>
          <p className="text-white/75 text-base mb-10 leading-relaxed">
            Collect early-access signups before you launch. Drop in one script tag and start
            building your audience — no backend required.
          </p>

          <ul className="flex flex-col gap-3">
            {features.map((feature) => (
              <li key={feature} className="flex items-start gap-3 text-white/90 text-sm">
                <CheckCircle2 className="mt-0.5 shrink-0 text-mint" size={18} strokeWidth={2.5} />
                {feature}
              </li>
            ))}
          </ul>

          <div className="mt-12 pt-8 border-t border-white/10 text-white/50 text-xs">
            Trusted by indie hackers and solo founders who ship.
          </div>
        </div>
      </div>
    </div>
  );
}
